import { GenericLabel } from '@com-delta-idp/mnx-utils';
import {
  CardCarouselBanner,
  BannerImage
} from '../../models/banner.interfaces';

export const BannerImageBlueCardMocks: BannerImage = {
  alt: 'Delta SkyMiles Blue Card',
  src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/amex-blue-card.png',
  show: true,
  position: 'right'
};

export const BannerContentBlueCardMocks: GenericLabel = {
  title: 'Delta SkyMiles® Blue Card Member',
  subtitle: ''
};

export const BannerBlueCardMocks: CardCarouselBanner = {
  labels: BannerContentBlueCardMocks,
  image: BannerImageBlueCardMocks
};
